import { render, staticRenderFns } from "./StadiumInfo.vue?vue&type=template&id=0cc54881&"
import script from "./StadiumInfo.vue?vue&type=script&lang=js&"
export * from "./StadiumInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cc54881')) {
      api.createRecord('0cc54881', component.options)
    } else {
      api.reload('0cc54881', component.options)
    }
    module.hot.accept("./StadiumInfo.vue?vue&type=template&id=0cc54881&", function () {
      api.rerender('0cc54881', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/StadiumInfo.vue"
export default component.exports